import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import { Button } from '@mui/material'
import { IoShareSocialOutline } from 'react-icons/io5'
import { AiOutlineEdit } from 'react-icons/ai'
import objectStore from '../../stores/objectStore'
import logger from '../../utils/logger'


function ObjectCardDefault({ object }) {
	const [renderedTitle, setRenderedTitle] = useState('')

	/*  	// Функция для парсинга шаблона
	function parseTemplate(template, values) {
		return template.replace(/{(\w+)}/g, (_, key) => values[key] || '')
	}

 	useEffect(() => {
		// Получаем шаблон cardTitleRender для текущего объекта
		const cardTitleTemplate = objectStore.getCardTitleRenderById(
			object.categoryId
		)

		if (cardTitleTemplate) {
			// Парсим шаблон с данными объекта
			const parsedTitle = parseTemplate(cardTitleTemplate, {
				...object,
				object, // Для поддержки вложенных значений
			})
			setRenderedTitle(parsedTitle)
		} else {
			setRenderedTitle('Шаблон не найден')
		}
	}, [object]) // Вызываем эффект при изменении объекта 
  */
	// Функция для вывода отладочной информации
	function getMe() {
		logger.log(`object: ${JSON.stringify(object)}`)
		logger.log('Rendered Title: ', renderedTitle)
	}

	return (
		<>
			<Card sx={{ maxWidth: 345 }}>
						<p>Карточка объекта</p>
				<CardMedia
					sx={{ height: 140 }}
					image='./public/mocks/foto.jpg'
					title='Изображение отсутствует'
				/>
				<CardContent>
					{/* Отображаем отрендеренный заголовок */}
					<Typography gutterBottom variant='h6' component='div'>
						{object.renderTitle}
					</Typography>
					<Typography gutterBottom variant='h6' component='div'>
						{object.city}
					</Typography>
					<div>Цена: {object.price}</div>
				</CardContent>
				<CardActions className='flex flex-row justify-end'>
			{/* 		<Button size='small' startIcon={<IoShareSocialOutline />}></Button> */}
					<Button size='small' startIcon={<AiOutlineEdit />}></Button>
				</CardActions>
			</Card>
		</>
	)
}

export default ObjectCardDefault
